import * as React from 'react';

interface NodeOptions {
  color: string;
  y: number;
  height?: number;
}

interface QuestionConnectorProps extends React.SVGProps<SVGSVGElement> {
  nodes: NodeOptions[];
}

const CONNECTOR_WIDTH = 43; // from figma design
const DOT_WIDTH_HEIGHT = 34;

function QuestionConnector(props: QuestionConnectorProps) {
  const { nodes, ...rest } = props;
  if (nodes.length === 0 || Boolean(nodes?.[0].height) === false) return null;
  const maxNodeHeight = nodes[nodes.length - 1].y + nodes[nodes.length - 1].height;
  return (
    <svg width={CONNECTOR_WIDTH} height={maxNodeHeight} fill="none" {...rest}>
      <path
        d="M15.631 8c0 3.988-3.315 7.25-7.44 7.25C4.063 15.25.75 11.988.75 8S4.064.75 8.19.75c4.127 0 7.441 3.262 7.441 7.25z"
        fill="#fff"
        stroke={nodes[0].color}
        strokeWidth={1.5}
      />
      <ellipse cx={8.19} cy={8} rx={4.095} ry={4} fill={nodes[0].color} />
      {nodes.map((node) => {
        const { color, y, height } = node;
        const centerNodeY = y + height / 2 - DOT_WIDTH_HEIGHT;
        const lineY = centerNodeY + DOT_WIDTH_HEIGHT - 35;
        const circleY = y + height / 2 + DOT_WIDTH_HEIGHT - 35;
        return (
          <React.Fragment key={y}>
            <path
              d={`M8 ${16}v${lineY}c0 9.941 8.059 18 18 18h9`}
              stroke={color}
              strokeWidth={2}
              strokeDasharray="4 5"
            />
            <path
              d={`M42.25 ${circleY}c0 3.988-3.314 7.25-7.44 7.25s-7.44-3.262-7.44-7.25c0-3.987 3.314-7.25 7.44-7.25s7.44 3.263 7.44 7.25z`}
              fill="#fff"
              stroke={color}
              strokeWidth={1.5}
            />
            <ellipse cx={34.81} cy={circleY} rx={4.095} ry={4} fill={color} />
          </React.Fragment>
        );
      })}
    </svg>
  );
}

const MemoQuestionConnector = React.memo(QuestionConnector);
export default MemoQuestionConnector;
